import type { JSX } from 'react';
import { Navigate, Outlet } from 'react-router';

import { paths } from '@/config/paths';
import { useAuthSession } from '@/hooks/use-auth-session';

export const LoginGuard = (): JSX.Element => {
  const { isLoading, isAuthenticated } = useAuthSession();

  if (isLoading) {
    return <div>Logging you in...</div>;
  }

  if (isAuthenticated) {
    return <Navigate to={paths.root.getHref()} replace />;
  }

  // Not authenticated, show the login page.
  return <Outlet />;
};
